import { render, staticRenderFns } from "./ActivitiesSettings.vue?vue&type=template&id=02acc59c&"
import script from "./ActivitiesSettings.vue?vue&type=script&lang=js&"
export * from "./ActivitiesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports